module.exports = __webpack_public_path__ + "static/media/atendimento-3-mobile.734a1469.png";